export const UNAVAILABLE = 'UNAVAILABLE' //Grey
export const AVAILABLE = 'AVAILABLE' // Blue
export const NORMAL = 'NORMAL' // Green
export const DISTRESS = 'DISTRESS' // Orange
export const ACCENT = 'ACCENT' // Purple
export const ERROR = 'ERROR' // Red
export const INACTIVE = 'INACTIVE' // dark orange
